<template>
    <b-card>
        <b-row>
            <b-col cols="12" xl="6" class="d-flex justify-content-between flex-column">
                <div class="d-flex justify-content-start">
                    <b-avatar :src="userData.avatar" :text="avatarText" variant="light-primary" class="badge-minimal"
                        size="104px" rounded />
                    <div class="d-flex flex-column ml-1">
                        <div class="mb-1">
                            <h4 class="mb-0">
                                {{ userData.lastName }} {{ userData.firstName }}
                            </h4>
                            <span class="card-text">{{ userData.mail }}</span>
                        </div>
                    </div>
                </div>

                <!-- <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="CalendarIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                {{ formatDate(userData.fonctionDate ? userData.fonctionDate : '') }}
              </h5>
              <small> Date de prise de fonction</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar
              variant="light-success"
              rounded
            >
              <feather-icon
                icon="PhoneIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                {{ userData.telephone }}
              </h5>
              <small>Contact</small>
            </div>
          </div>
        </div> -->
            </b-col>


            <b-col cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <tr>
                        <th>
                            <feather-icon icon="BriefcaseIcon" class="mr-75" />
                            <span class="font-weight-bold">Fonction</span>
                        </th>
                        <td>
                            {{ userData.fonction }} {{ userData.toll && userData.toll.name ? userData.toll.name : '' }}
                        </td>
                    </tr>
                    <tr v-if="userData.services && userData.services.name">
                        <th>
                            <feather-icon icon="MapPinIcon" class="mr-75" />
                            <span class="font-weight-bold">Service</span>
                        </th>
                        <td>
                            {{ userData.services ? userData.services.name : '' }}
                        </td>
                    </tr>
<!--                    <tr v-if ="userData.directions">-->
<!--                        <th>-->
<!--                            <feather-icon icon="MapPinIcon" class="mr-75" />-->
<!--                            <span class="font-weight-bold">{{ userData.directions ? userData.directions.type : ''}}</span>-->
<!--                        </th>-->
<!--                        <td>-->
<!--                            {{ userData.directions ? userData.directions.name : '' }}-->
<!--                        </td>-->
<!--                    </tr>-->
                    <tr>
                        <th>
                            <feather-icon icon="PhoneIcon" class="mr-75" />
                            <span class="font-weight-bold">Contact</span>
                        </th>
                        <td>
                            {{userData.telephone ? formatPhoneNumber(userData.telephone) : ''}}
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <feather-icon icon="CalendarIcon" class="mr-75" />
                            <span class="font-weight-bold">Prise de fonction</span>
                        </th>
                        <td>
                            {{ formatDate(userData.fonctionDate ? userData.fonctionDate : '') }}
                        </td>
                    </tr>



                </table>

            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { BCard, BAvatar, BRow, BCol } from 'bootstrap-vue'

export default {
    components: {
        BCard,
        BRow,
        BCol,
        BAvatar,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const avatarText = (props.userData.firstName ? props.userData.firstName.charAt(0) : '') +
            (props.userData.lastName ? props.userData.lastName.charAt(0) : '')

        return {
            avatarText,
        }
    },
    methods:{
      formatPhoneNumber(number) {
        return number.replace(/(\d{2})(?=(\d{2})+(?!\d))/g, '$1 ').trim();
      },
        formatDate(date) {
      if (!date) return '';

      // Check if date is an array
      if (Array.isArray(date)) {
        const [year, month, day] = date;
        return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
      }

      // Check if date is a string
      if (typeof date === 'string') {
        const [day, month,year ] = date.split('-');
        return `${day}-${month}-${year}`;
      }

      // Handle invalid date format
      console.error('Invalid date format:', date);
      return '';
    },
  },
}
</script>
